import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Clock, ArrowRight, Calendar } from "lucide-react";
import PublicLayout from "../components/PublicLayout";
import SEO from "../components/SEO";
import { apiClient } from "../lib/api";

export default function BlogPage() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    apiClient.get("/blog").then((r) => setPosts(r.data));
  }, []);

  return (
    <PublicLayout>
      <SEO
        title="Blog conciergerie et rentabilité Airbnb en Bretagne"
        description="Articles d'experts sur la rentabilité Airbnb à Saint-Malo, Dinard, Cancale, Dinan. Conseils, stratégies et études de marché par Bretagne Conciergerie Comparateur."
      />
      <section className="pt-12 pb-8 md:pt-20 md:pb-12">
        <div className="container-tm max-w-4xl">
          <span className="pill">Le blog</span>
          <h1 className="h-display mt-5">
            Tout savoir sur la<br />
            <span className="text-accent">rentabilité Airbnb</span>
          </h1>
          <p className="mt-6 text-muted-foreground text-lg max-w-2xl">
            Conseils, études de marché et stratégies d&apos;investissement pour maximiser vos revenus locatifs sur la Côte d&apos;Émeraude.
          </p>
        </div>
      </section>

      <section className="pb-20">
        <div className="container-tm">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {posts.map((p, idx) => (
              <Link key={p.slug} to={`/blog/${p.slug}`} className="block group" data-testid={`blog-card-${p.slug}`}>
                <article className="surface-card overflow-hidden hover:border-accent transition-colors h-full flex flex-col">
                  <div className="relative aspect-[4/3] overflow-hidden bg-secondary">
                    <img loading="lazy" src={p.cover} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                    <div className="absolute top-4 left-4 px-3 py-1.5 bg-white rounded-full text-xs font-bold">
                      {p.category}
                    </div>
                  </div>
                  <div className="p-6 flex-1 flex flex-col">
                    <div className="flex items-center gap-3 text-xs text-muted-foreground">
                      <span className="flex items-center gap-1"><Calendar size={11} /> {new Date(p.published_at).toLocaleDateString("fr-FR")}</span>
                      <span className="flex items-center gap-1"><Clock size={11} /> {p.read_time} min</span>
                    </div>
                    <h3 className="h-card mt-3 group-hover:text-accent transition-colors">
                      {p.title}
                    </h3>
                    <p className="text-sm text-muted-foreground mt-3 leading-relaxed line-clamp-3">{p.excerpt}</p>
                    <div className="mt-5 pt-5 border-t border-border flex items-center justify-between text-sm">
                      <span className="text-muted-foreground">{p.author}</span>
                      <span className="text-accent font-medium inline-flex items-center gap-1 group-hover:gap-2 transition-all">
                        Lire <ArrowRight size={13} />
                      </span>
                    </div>
                  </div>
                </article>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </PublicLayout>
  );
}
